import { Button } from "@pdfking/components"

import { Layout } from "../components/Layout"
import { Link } from "../router"

export const Home = () => (
  <Layout active="home" panel={undefined}>
    <section className="mx-auto flex max-w-2xl flex-col items-center gap-6 px-6 py-24 text-center">
      <h1 className="text-4xl font-semibold">PDF imposition, in the browser</h1>
      <p className="text-lg text-muted-foreground">
        A self-contained, embeddable PDF imposition viewer: preview, impose and inspect print-ready
        PDFs in 2D and 3D.
      </p>
      <Button asChild size="lg">
        <Link name="viewer">Open PDF View</Link>
      </Button>
    </section>
  </Layout>
)
